import { useMutation } from '@tanstack/react-query';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeObjectionResponse = (payload: { id: string; aiId: number }) => {
  const { id } = payload;

  return axios.delete(`/ai/objection-responses/${id}`);
};

type QueryFnType = typeof removeObjectionResponse;

type UseRemoveObjectionResponseOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useRemoveObjectionResponse = ({ config }: UseRemoveObjectionResponseOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    mutationFn: removeObjectionResponse,
    onSuccess: (_data, variables, context) => {
      queryClient.invalidateQueries(['objection-responses', variables.aiId]);
      onSuccess?.(_data, variables, context);
    },
  });
};
